
import React, { useState } from 'react';
import { useParams } from "react-router-dom";
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';

// import NavBar_v03Responsive from './NavBar_v03a_Responsive_component';
import { IAppConfig, IAddress, IOperatingHours } from "../App_v01_Interfaces";


interface AppConfigProps{
  appConfig: IAppConfig;
}



// const Contact: React.FC = () => {


//MACHINE ROUTE PARAMS
type MachineRouteParams = {
  machineId: string;
};



const Contact_v01: React.FC<AppConfigProps> = ({ appConfig }) => {
  const { machineId } = useParams<MachineRouteParams>();

  const [isProcessing, setIsProcessing] = useState(false);

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    domainName: window.location.hostname,
    itemCategory: 'Customer',
    itemClass: 'WebForm',
    itemType: 'Feedback',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

const isTestMode = false; // ✅ Toggle this to false in production

const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();
  setIsProcessing(true);

  if (isTestMode) {
    console.log('🚧 TEST MODE: Skipping API call.');
    console.table({
      domainName: formData.domainName,
      customerName: formData.name,
      emailAddress: formData.email,
      message: formData.message,
      itemCategory: formData.itemCategory,
      itemClass: formData.itemClass,
      itemType: formData.itemType,
    });

    setFormSubmitted(true);
    setErrorMessage('');
    return;
  } //end:isTestMode

  try {
    const response = await fetch(appConfig.contactPageAPIUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        domainName: formData.domainName,
        customerName: formData.name,
        emailAddress: formData.email,
        message: formData.message,
        itemCategory: formData.itemCategory,
        itemClass: formData.itemClass,
        itemType: formData.itemType,
      }),
    });

    if (!response.ok) {
      setIsProcessing(false);
      throw new Error(`Server responded with ${response.status}`);
    }

    setFormSubmitted(true);
    setIsProcessing(false);
    setErrorMessage('');
  } catch (err: any) {
    setIsProcessing(false);
    setErrorMessage('Cloud Network Error. This form is offline. Please send your message using regular email. Thank you! :)');
    console.error(err);
  }
};




  // const handleSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();

  //   try {
  //     const response = await fetch(appConfig.contactPageAPIUrl, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         domainName: formData.domainName,
  //         customerName: formData.name,
  //         emailAddress: formData.email,
  //         message: formData.message,
  //         itemCategory: formData.itemCategory,
  //         itemClass: formData.itemClass,
  //         itemType: formData.itemType,
  //       }),
  //     });

  //     if (!response.ok) {
  //       throw new Error(`Server responded with ${response.status}`);
  //     }

  //     setFormSubmitted(true);
  //     setErrorMessage('');
  //   } catch (err: any) {
  //     setErrorMessage('Cloud Network Error. This form is offline. Please send your message using regular email. Thank you! :)');
  //     console.error(err);
  //   }
  // };




  const feedbackContent = machineId  === "M1290H" ? (
    <>
      Feedback for Machine <strong>{machineId}</strong>
        <br></br>
        Located at: 
        <img src="../sundance-images/customerLogo-qxo.png"
        alt="Customer Logo - QXO"
        style={{ width: "75px", height: "auto" }}
      
      ></img>
      <br></br>
      <>Please provide your feedback below.  If you have encountered a problem with a machine, please provide the details below and a way to contact you.</>

    </>
    ) : (
      <>Please provide your feedback below.  If you have encountered a problem with a machine, please provide the details below and a way to contact you.</>
    );

  return (
    <>
      {/* <NavBar_v03Responsive appConfig={appConfig} /> */}

      <section className="py-5">
        <Container>
          <Row className="mb-4">
            <Col>
            
            <p>{appConfig.ContactUsPage.Headline}</p>
            <p>
              {feedbackContent}

            {/* {machineId
                ? `Feedback for Machine <b>${machineId}</b>`
                : "Please provide your feedback below.  If you have encountered a problem with a machine, please provide the details below and a way to contact you."} */}
           </p>
             
          </Col>
            
          </Row>

          <Row>
            <Col md={6}>
              {!formSubmitted ? (
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="name">
                    <Form.Label>Your Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter your name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="email">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter your email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="message">
                    <Form.Label>Your Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      placeholder="What can we help you with?"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <input type="hidden" id="domainName" value={formData.domainName} />
                  <input type="hidden" id="itemCategory" value={formData.itemCategory} />
                  <input type="hidden" id="itemClass" value={formData.itemClass} />
                  <input type="hidden" id="itemType" value={formData.itemType} />

                  <Button variant="primary" type="submit" disabled={isProcessing}>
                    {isProcessing ? 'Processing...' : 'Send Message'}
                  </Button>
                </Form>
              ) : (
                <div className="p-3 rounded border" style={{ backgroundColor: 'var(--bs-success-bg-subtle)' }}>
                  <h5>Thank you! A representative will be following up with you shortly.</h5>
                  
                  <p><strong>Name:</strong> {formData.name}</p>
                  <p><strong>Email:</strong> {formData.email}</p>
                  <p><strong>Message:</strong> {formData.message}</p>
                  {/* <p><strong>Domain:</strong> {formData.domainName}</p> */}
                  {/* <p><strong>Category:</strong> {formData.itemCategory}</p> */}
                  {/* <p><strong>Class:</strong> {formData.itemClass}</p> */}
                  {/* <p><strong>Type:</strong> {formData.itemType}</p> */}
                </div>
              )}

              {errorMessage && (
                <Alert variant="danger" className="mt-3">
                  {errorMessage}
                </Alert>
              )}
            </Col>

            <Col md={6}>


              {
                  appConfig.hideContactAddressInfo === true
                    ? ''
                    : (
                      <>
                                  <p><strong>{appConfig.companyLegalName}</strong></p>
                                  <p>
                                    {appConfig.address.street1}, {appConfig.address.street2}
                                    <br />
                                    {appConfig.address.city}, {appConfig.address.state} {appConfig.address.zip}
                                  </p>
                                  <p>Email: {appConfig.infoeMail}</p>
                              

                                  <p>Phone: <a href={"tel:" + appConfig.companyMainPhone}>{appConfig.companyMainPhone}</a></p> 
                                  

                                  {appConfig.operatingHours.MF ?
                                              <>
                                              <h5>Service Hours</h5>
                                              <p>
                                                {appConfig.operatingHours.MF}
                                                <br />
                                                {appConfig.operatingHours.SA}
                                                <br />
                                                {appConfig.operatingHours.SU}
                                              </p>
                                              </>
                                  : ''}

                                  

                      </>
                      )
                    }
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Contact_v01;




const Contact_v01a: React.FC<AppConfigProps> = ({ appConfig }) => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    domainName: window.location.hostname,
    itemCategory: 'Customer',
    itemClass: 'WebForm',
    itemType: 'Feedback',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const response = await fetch( appConfig.contactPageAPIUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          domainName:     formData.domainName,
          customerName:   formData.name,
          emailAddress:   formData.email,
          message:        formData.message,
          itemCategory:   formData.itemCategory,
          itemClass:      formData.itemClass,
          itemType:       formData.itemType,
        }),
      });

      if (!response.ok) {
        throw new Error(`Server responded with ${response.status}`);
      }

      setFormSubmitted(true);
      setErrorMessage('');
    } catch (err: any) {
      setErrorMessage('Cloud Network Error. This form is offline. Please send your message using regular email. Thank you! :)');
      console.error(err);
    }
  };

  return (
    <>
      {/* <NavBar_v03Responsive appConfig={appConfig} /> */}

      <section className="py-5">
        <Container>
          <Row className="mb-4">
            <Col>{appConfig.ContactUsPage.Headline}</Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="name">
                  <Form.Label>Your Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="email">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="message">
                  <Form.Label>Your Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    placeholder="What can we help you with?"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                {/* Hidden Fields */}
                <input type="hidden" id="domainName"    value={formData.domainName} />
                <input type="hidden" id="itemCategory"  value={formData.itemCategory} />
                <input type="hidden" id="itemClass"     value={formData.itemClass} />
                <input type="hidden" id="itemType"      value={formData.itemType} />

                <Button variant="primary" type="submit">
                  Send Message
                </Button>
              </Form>

              {formSubmitted && !errorMessage && (
                <Alert variant="success" className="mt-3">
                  Thank you! A representative will be following up with you shortly.
                </Alert>
              )}

              {errorMessage && (
                <Alert variant="danger" className="mt-3">
                  {errorMessage}
                </Alert>
              )}
            </Col>

            <Col md={6}>
              {/* <h5>Contact Details</h5> */}
              <p><strong>{appConfig.companyLegalName}</strong></p>
              <p>
                {appConfig.address.street1}, {appConfig.address.street2}
                <br />
                {appConfig.address.city}, {appConfig.address.state} {appConfig.address.zip}
              </p>
              <p>Email: {appConfig.infoeMail}</p>
              <p>Phone: {appConfig.companyMainPhone}</p>

              <h5>Service Hours</h5>
              <p>
                {appConfig.operatingHours.MF}
                <br />
                {appConfig.operatingHours.SA}
                <br />
                {appConfig.operatingHours.SU}
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

// export default Contact_v01a;




 const Contact_v01_original: React.FC<AppConfigProps> = ({appConfig}) => {

  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormSubmitted(true);

    // In production: Send data to a backend or service like EmailJS / Formspree
  };

  return (

    <>
     {/* <NavBar_v03Responsive appConfig={appConfig} /> */}
    
    <section className="py-5">
      <Container>
        <Row className="mb-4">
          <Col>
           
           {appConfig.ContactUsPage.Headline}

          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="name">
                <Form.Label>Your Name</Form.Label>
                <Form.Control type="text" placeholder="Enter your name" required />
              </Form.Group>

              <Form.Group className="mb-3" controlId="email">
                <Form.Label>EMail address</Form.Label>
                <Form.Control type="email" placeholder="Enter your email" required />
              </Form.Group>

              <Form.Group className="mb-3" controlId="message">
                <Form.Label>Your Message</Form.Label>
                <Form.Control as="textarea" rows={4} placeholder="What can we help you with?" required />
              </Form.Group>

              <Button variant="primary" type="submit">
                Send Message
              </Button>
            </Form>

            {formSubmitted && 
                              (
                                <Alert variant="success" className="mt-3">
                                  {/* Thanks! We’ll get back to you shortly. */}
                                  Cloud Network Error.  This form is offline. Please send your message using regular email.  Thank you! :)
                                </Alert>
                              )
            }
          </Col>

          <Col md={6}>
            {/* <h5>Contact Details</h5> */}
            <p><strong>{appConfig.companyLegalName}</strong></p>
            <p>{appConfig.address.street1}, {appConfig.address.street2}<br />{appConfig.address.city}, {appConfig.address.state} {appConfig.address.zip}</p>
            <p>EMail: {appConfig.infoeMail}</p>
            <p>Phone: {appConfig.companyMainPhone}</p>

            <h5>Service Hours</h5>
            <p>{appConfig.operatingHours.MF}<br />{appConfig.operatingHours.SA}<br />{appConfig.operatingHours.SU}</p>
          </Col>
        </Row>
      </Container>
    </section>
    </>

  );
};

// export default Contact_v01_original;




// const Contact_v01: React.FC<AppConfigProps> = ({appConfig}) => {
//   return (
//     <>
//       {/* <Navbar_v01 appConfig={appConfig}/> */}
//       <NavBar_v03LeftRight appConfig={appConfig} />

//       <div className='container mt-5'>
//         <h2>Contact_v01</h2>
//         <p>Welcome to the Contact_v01 page of Cost Crusher Insurance.</p>
//       </div>
//     </>
//   );
// };

// export default Contact_v01;
